enum NotificationType {
    info = 'info',
    success = 'success',
    warning = 'warning',
    error = 'error'
}

export {NotificationType}  